import React from 'react';
import Icon from '../../design-system/primitives/Icon';

/**
 * Headline numbers. `tiles`: [{ key, label, value, sub, icon, tone }].
 * `value` is pre-formatted; `sub` is the in-window figure ("12 in 30d").
 */
const KpiTiles = ({ tiles }) => (
  <div className="qa-tiles">
    {tiles.map((t) => (
      <div key={t.key} className={`qa-tile ${t.tone ? `qa-tile--${t.tone}` : ''}`}>
        <div className="qa-tile__label">
          {t.icon && <Icon name={t.icon} size={12} />}
          {t.label}
        </div>
        <div className="qa-tile__value">{t.value}</div>
        {t.sub && <div className="qa-tile__sub">{t.sub}</div>}
      </div>
    ))}
  </div>
);

export default KpiTiles;
